import React from 'react';
import AlertCreateManageSection from '@components/catalog/alerts/alerts-create-manage-section/alerts-create-manage-section';
import useAlertsCriteria, {
  areAlertCriteriaTooBroad,
} from '@components/catalog/alerts/alerts-create-manage-section/use-alerts-criteria';
import { useRouter } from 'next/router';

interface SaveSearchButtonProps {
  setAlertError: (error: string) => void;
  customClassName?: string;
}

const SaveSearchButton: React.FC<SaveSearchButtonProps> = ({ setAlertError, customClassName }) => {
  const { query } = useRouter();
  const alertCriteria = useAlertsCriteria();

  const hideAlert = query?.alertStatus === 'hide' || areAlertCriteriaTooBroad(alertCriteria);

  if (hideAlert) {
    return null;
  }

  return (
    <AlertCreateManageSection
      key="alert-create-manage"
      alertCriteria={alertCriteria}
      setAlertError={setAlertError}
      customClassName={customClassName}
    />
  );
};

export default SaveSearchButton;
